import type { TableColumn } from 'liyu-pc-base/typing';
import type { Record, SearchConfig } from 'liyu-pc-base/components/remotePages/typing';
import { btn_list, head_btn_list } from './permission-menu-config';
import { event_obj } from 'liyu-pc-base/init-plugin';
import { reactive } from 'vue';
import { useEnv } from 'liyu-pc-base/init-plugin';
import { useUserStore } from 'liyu-pc-base/init-plugin';

export default () => {
  const env = useEnv();
  const userStore = useUserStore();
  const current_org = userStore.currentOrg; // 当前组织org
  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        name: 'is_active',
        label: '是否可用',
        disabled: false,
        allowClear: true,
        placeholder: '请选择是否可用',
        type: 'select',
        labelKey: 'name',
      },
      {
        type: 'remoteselectpro',
        name: 'aim_org_id',
        label: '目标组织',
        disabled: false,
        placeholder: '请选择目标组织',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        labelKey: 'name',
        valueKey: 'id',
        postUrl: '/org/query_organization_list',
      },
      {
        type: 'input',
        name: 'name',
        label: '菜单名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写角色名称',
      },
      {
        type: 'input',
        name: 'state',
        label: '路由',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写路由',
      },
      {
        type: 'remotetreeselectpro',
        name: 'parent_id',
        label: '父级菜单',
        label_i18n: '父级菜单',
        placeholder_i18n: '请选择父级菜单',
        disabled: false,
        allowClear: true,
        defaultValue: '',
        valueKey: 'value',
        labelKey: 'title',
        placeholder: '请选择父级菜单',
        postUrl: '/permission/query_menu_list__tree',
        init_model: {
          aim_org_id: current_org?.id,
        },
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org.id,
      aim_org_id: current_org.id,
      tree_struct_simulation: true,
      is_active: true,
      get_menu: true,
      state: null,
      parent_id: null,
      name: null,
    }),
    options: {
      is_active: [
        { name: '可用', value: true },
        { name: '禁用', value: false },
      ],
    },
    default_column_field: ['parent_id', 'index'],
  };

  const titleList = {
    title: '权限管理',
    addModalTitle: '新建角色',
    updateTitle: '修改',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: 'permission/delete_menu', // 是否有【删除】按钮
    is_recover: 'permission/recover_menu', // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      menu_id: 'id',
    },
    delete: {
      menu_id: 'id',
    },
    recover: {
      menu_id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      menu_id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: 'id',
      dataIndex: 'id',
      width: 80,
      checked: false,
      fixed: 'left',
    },
    {
      title: '名称',
      width: 300,
      checked: true,
      dataIndex: 'name',
      fixed: 'left',
    },
    {
      title: '索引',
      width: 60,
      checked: true,
      dataIndex: 'sort',
    },
    {
      title: '菜单图标',
      width: 100,
      dataIndex: 'icon',
      checked: true,
      resizable: true,
      cellComponent: 'icon',
    },
    {
      title: ' 菜单标识',
      dataIndex: 'state',
      checked: true,
      resizable: true,
    },
    {
      title: '菜单地址',
      dataIndex: 'menu_path',
      checked: true,
      resizable: true,
    },
    {
      title: ' 路由名称',
      dataIndex: 'menu_name',
      checked: false,
      resizable: true,
    },
    {
      title: '组件地址',
      dataIndex: 'component',
      width: 300,
      checked: false,
      resizable: true,
    },
    {
      title: '隶属组织列表',
      dataIndex: 'org_id_list',
      minWidth: 400,
      checked: false,
      cellComponent: 'json_tag',
      resizable: true,
    },
    {
      title: '平台',
      dataIndex: 'platform',
      minWidth: 100,
      checked: true,
      cellComponent: 'tag',
      contentMap: {
        '10': 'PC',
        '11': 'PC 隐藏菜单',
        '12': 'PC 隐藏子菜单',
        '20': '手机端',
      },
      colorMap: {
        '10': 'green',
        '11': 'yellow',
        '12': 'orange',
        '20': 'red',
      },
    },

    {
      title: '是否菜单',
      dataIndex: 'is_menu',
      width: 80,
      checked: true,
      resizable: true,
      cellComponent: 'boolean',
      name1: '菜单',
      name2: '按钮',
    },
    {
      title: '菜单帮助',
      dataIndex: 'helper_files',
      minWidth: 100,
      checked: true,
      cellComponent: 'pdf',
      formatExcelValue: 'file',
    },
    {
      title: '状态',
      width: 100,
      dataIndex: 'is_active',
      checked: true,
      resizable: true,
      cellComponent: 'boolean',
      name1: '可用',
      name2: '禁用',
      filterMultiple: false,
      filters: [
        { text: '可用', value: 'true' },
        { text: '禁用', value: 'false' },
      ],
    },
    {
      title: '对应接口',
      dataIndex: 'url_id_list',
      width: 800,
      checked: false,
      cellComponent: 'list',
    },
    {
      title: '扩展属性',
      dataIndex: 'options',
      checked: false,
      cellComponent: 'json',
      resizable: true,
    },
    {
      title: '操作',
      width: 50,
      dataIndex: 'action',
      checked: true,
      cellComponent: 'action',
      fixed: 'right',
    },
  ];
  if (env.VITE_APP_HAS_PROJECT) {
    baseColumns.splice(5, 0, {
      title: '模块',
      dataIndex: 'menu_project__name',
      minWidth: 100,
      checked: true,
    });
    search_config.fields.push({
      type: 'remotetreeselectpro',
      name: 'menu_project',
      label: '模块',
      label_i18n: '模块',
      placeholder_i18n: '请选择模块',
      disabled: false,
      allowClear: true,
      defaultValue: '',
      valueKey: 'project',
      labelKey: 'name',
      placeholder: '请选择模块',
      postUrl: '/i18n/query_language_project_list',
    });
  }
  return {
    searchConfig: search_config,
    queryData: '/permission/query_menu_list__tree',
    baseColumns,
    titleList,
    api_fields,
    btn_list,
    head_btn_list,
    event_obj: event_obj(),
    is_show_advantage: false,
    is_show_normal_search: true,
    is_only_show_advantage: false,
    is_only_show_normal_search: true,
    isView: false,
  };
};
